import React from 'react'
import styled from '@emotion/styled'
import Star from '~/icons/Star'

const StarRating = props => {
  const { children, fill, size = 20 } = props
  return (
    <Wrapper {...props}>
      <Star fill={fill} size={size} />
      <Star fill={fill} size={size} />
      <Star fill={fill} size={size} />
      <Star fill={fill} size={size} />
      <Star fill={fill} size={size} />
      {children && <Label>{children}</Label>}
    </Wrapper>
  )
}

export default StarRating

export const Wrapper = styled.div`
  font-family: 'SohneBreit';
  font-weight: 400;
  letter-spacing: 1px;

  display: flex;
  align-items: center;
`

export const Label = styled.div`
  margin-left: 20px;
  /* text-transform: uppercase; */
  font-size: 14px;
`
